import { getDownloadURL, ref, uploadBytes, uploadString } from 'shared/services/firebase';

export default function useStorage(storage, user) {
  const getScreenshotFileName = () => {
    const date = new Date();
    return `Notix_Screenshot_${date.toISOString()}`;
  };

  const uploadScreenshot = (file) => {
    const fileRef = ref(
      storage,
      `${user.value.uid}/${getScreenshotFileName()}.jpg`,
    );
    if (typeof file === 'object') {
      return uploadBytes(fileRef, file, { contentType: file.contentType }).then((snapshot) => getDownloadURL(snapshot.ref).then((downloadURL) => ({
        src: downloadURL,
        name: `${getScreenshotFileName()}.jpg`,
      })));
    }
    return uploadString(fileRef, file, 'data_url', { contentType: 'image/jpeg' }).then((snapshot) => getDownloadURL(snapshot.ref).then((downloadURL) => ({
      src: downloadURL,
      name: `${getScreenshotFileName()}.jpg`,
    })));
  };

  const uploadFile = (file) => {
    const d = new Date();
    const fileName = `${d.toISOString()}_${file.name}`;
    const fileRef = ref(
      storage,
      `${user.value.uid}/${fileName}`,
    );
    if (typeof file === 'object') {
      return uploadBytes(fileRef, file, { contentType: file.contentType }).then((snapshot) => getDownloadURL(snapshot.ref).then((downloadURL) => ({
        src: downloadURL,
        name: fileName,
      })));
    }
    throw new Error('file object not supported');
  };

  const getScreenRecordingFileName = () => {
    const date = new Date();
    return `Notix_Screen_Recording_${date.toISOString()}.webm`;
  };

  const uploadScreenRecording = (file) => {
    console.log(file);
    const fileName = getScreenRecordingFileName();
    const fileRef = ref(
      storage,
      `${user.value.uid}/${fileName}`,
    );
    return uploadString(fileRef, file, 'data_url', { contentType: file.contentType }).then((snapshot) => getDownloadURL(snapshot.ref).then((downloadURL) => ({
      src: downloadURL,
      name: `${getScreenshotFileName()}.jpg`,
    })));
  };

  return { uploadScreenshot, uploadFile, uploadScreenRecording };
}
